function toFinite(input: null | undefined | number): number {
  return typeof input == 'number' && Number.isFinite(input) ? input : 0;
}

export function computePrice<T extends { price?: null | number }>(
  list: null | undefined | readonly T[],
): number {
  return list?.reduce((sum, item) => sum + toFinite(item.price), 0) || 0;
}
